import {Configuration} from "~/modules/Clients/models/Configuration";
import {IDetailsViewField} from "~/components/DetailsView";

export const configurationToDetailsView = (configuration: Configuration): IDetailsViewField[] => {
    const object = JSON.parse(configuration);
    return Object.keys(object).map(key => ({
        label: key,
        value: object[key]
    }));
};